import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import {
    routerMiddleware as createRouterMiddleware,
    ConnectedRouter,
} from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';

import { apiConfig, amplifyConfig, theme } from 'config';
import createRootReducer, { createLoggerMiddleware } from 'reducers';
import { appApi } from 'api';
import sagas from 'sagas';

import { CssBaseline, ThemeProvider, StyledEngineProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');
const history = createBrowserHistory();
const reducer = createRootReducer(history);

const routerMiddleware = createRouterMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLoggerMiddleware();

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware({ serializableCheck: false }).concat(
            routerMiddleware,
            sagaMiddleware,
            appApi.middleware,
            loggerMiddleware
        );
    },
});

amplifyConfig.initAmplify();
sagaMiddleware.run(sagas);
apiConfig.configureAxios(store);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
                            <CssBaseline />
                            <App />
                        </LocalizationProvider>
                    </ThemeProvider>
                </StyledEngineProvider>
            </ConnectedRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
